import { stringField, optionField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  type: optionField({ required: true })
};
